import axios from 'axios';
import { logout } from '../store/account/actions';
import { API_URL } from '../helpers/constants';

const api = axios.create({
  baseURL: `${API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});
/**
 intercept any error responses from the api
 and check if the token is no longer valid.
 ie. Token has expired or user is no longer
 authenticated.
 logout the user if the token has expired
**/

api.interceptors.response.use(
  (res: any) => res,
  (err: any) => {
    if (err.response.status === 401) {
      logout();
    } else {
      return err.response;
    }
  }
);
export { api };